const programTypes = {
	physicalTherapy: `physicalTherapy`,
	occupationalTherapy: `occupationalTherapy`,
	coach: `coach`,
	virtualMSK: `virtualMSK`,
};

export default programTypes;

export const programNames = programType => {
	switch (programType) {
		case programTypes.physicalTherapy:
			return `physicalTherapyProgram`;
		case programTypes.occupationalTherapy:
			return `occupationalTherapyProgram`;
		case programTypes.coach:
			return `coachingProgram`;
		case programTypes.virtualMSK:
			return `virtualMSKProgram`;
		default:
			return `homeExerciseProgram`; // Backward compatability
	}
};

export const hasFeedBackFeature = programType => {
	switch (programType) {
		case programTypes.coach:
		case programTypes.virtualMSK:
			return false;
		default:
			return true;
	}
};
